import axios from "axios";

import AuthService from '../Auth/AuthService';

export default class TipoEquipamentoService extends AuthService {


  /* LISTAR TODOS */
  listar() {
    return axios({
      method: 'get',
      url: this.api_url + 'tipoEquipamento',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + this.token(),
      },
    }).then(res => res.data);
  }
  /* CADASTRAR */
  criar(tipoEquipamento) {
    return axios({
      method: 'post',
      url: this.api_url + 'tipoEquipamento',
      withCredentials: true,
      data: tipoEquipamento,
      headers: {
        'Authorization': 'Bearer ' + this.token(),
      }
    });
  }
  /* REMOVER */
  remover(id) {
    return axios({
      method: 'delete',
      url: this.api_url + 'tipoEquipamento/' + id,
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + this.token(),
      }
    });

  }
  /* ATUALIZAR */
  atualizar(id, tipoEquipamento) {
    return axios({
      method: 'put',
      url: this.api_url + 'tipoEquipamento/' + id,
      withCredentials: true,
      data: tipoEquipamento,
      headers: {
        'Authorization': 'Bearer ' + this.token(),
      }
    });
  }
}
